import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DefaultGUID, RoleName } from 'src/app/@shared/constants/Constant';
import { CustomerService } from '@services/customer.service';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { IGroupChatFilterModel, ISrListGroupList } from 'src/app/model/internalGroupChat.model';
import { IFilterViewModel } from 'src/app/model/report.model';
import { IGetMemberViewModel } from 'src/app/service/memeber.model';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { VendorService } from 'src/app/service/vendor.service';
import { InternalGroupChatService } from '../internal-group-chat.service';

@Component({
  selector: 'app-internal-group-chat',
  templateUrl: './internal-group-chat.component.html',
  styleUrls: ['./internal-group-chat.component.css']
})
export class InternalGroupChatComponent implements OnInit, AfterViewInit, OnDestroy {
  private _subscriptions: Subscription = new Subscription();
  public user: ILoggedInUserViewModel;
  public loader: boolean;
  public totalMessageCountLoader: boolean;
  public totalMessageCount: number = 0;
  public sRListGroupList: ISrListGroupList[];
  public filteredSRListGroupList: ISrListGroupList[];
  public groupNameFilterText: string = '';
  public internalMemberList: IGetMemberViewModel[];
  public isFilterVisible: boolean;
  public getTripIdDataModel = {
    tripIdList: [] as string[],
    tripIdDropdownSettings: {
      singleSelection: false,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      idField: 'id',
      textField: 'name',
    },
    selectedTripIdList: [],
  };
  public getCustomerDataModel = {
    customerList: [],
    customerDropdownSettings: {
      singleSelection: false,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      idField: 'customerID',
      textField: 'customerName',
    },
    selectedCustomerList: [],
  };
  screenChange = window.addEventListener('orientationchange', function () {
    this.window.location.reload();
  }, false);

  constructor(
    private _toast: ToastrService,
    private _serviceRequestService: ServiceRequestService,
    private _customerService: CustomerService,
    private _internalGroupChatService: InternalGroupChatService,
    private _vendorService: VendorService,
  ) { }

  ngOnInit() {
    this.loader = true;
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isFilterVisible = this.user.role === RoleName.ExecutiveAdmin || this.user.role === RoleName.Coordinator || this.user.role === RoleName.Management;
    let getSRListGroupListPayload = {
      memberId: this.user.memberId,
      serviceRequestId: null,
      messageText: null
    }
    this.getGroupChatList(getSRListGroupListPayload);
    if (this.isFilterVisible) {
      this.getTripIDList();
      this.getCustomerList();
    }
    if (this.user.role !== RoleName.CustomerAdmin && this.user.role !== RoleName.CustomerCoordinator && this.user.role !== RoleName.VendorAdmin && this.user.role !== RoleName.VendorCoordinator && this.user.role !== RoleName.VendorDriver && this.user.role !== RoleName.InternalReadOnly) {
      this.getInternalMemberList();
    }
  }

  ngAfterViewInit(): void {
    this.getTripIdBasedOnSearchText();
    this.getFilteredServiceRequestBasedOnSearchedText();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  getGroupChatList(groupChatFilterPayload: IGroupChatFilterModel) {
    this.loader = true;
    this._subscriptions.add(
      this._internalGroupChatService.getSRListGroupList(groupChatFilterPayload).subscribe(
        (response) => {
          this.sRListGroupList = response.data;
          this.filteredSRListGroupList = this.sRListGroupList;
          this.filterGroupChatList();
          this.loader = false;
        },
        (error) => {
          this.loader = false;
          console.log(error);
          this._toast.warning('Unable to get the chat list!', 'Warning',
            {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            });
        }
      )
    );
  }

  getCustomerList() {
    this._subscriptions.add(
      this._customerService.getFilteredCustomerList().subscribe(
        (response) => {
          this.getCustomerDataModel.customerList = response?.filter((customer) => customer.customerName !== null && customer.customerName !== '');
          this.loader = false;
        },
        (error) => {
          console.log(error);
        }
      )
    );
  }

  getTripIDList() {
    this.loader = true;
    let memberID: string = (this.user.role === RoleName.CustomerAdmin || this.user.role === RoleName.CustomerCoordinator) ? this.user.businessUnitId : DefaultGUID;
    this._subscriptions.add(
      this._serviceRequestService.getFilterData(memberID).subscribe(
        (response) => {
          this.getTripIdDataModel.tripIdList = response?.filter(result => result.tripId != '').map((res) => res.tripId);
        })
    );
  }

  getInternalMemberList() {
    this.loader = true;
    this._subscriptions.add(
      this._vendorService.getMemberListByCustomerID(DefaultGUID).subscribe(
        (response) => {
          this.internalMemberList = response;
          this.loader = false;
        },
        (error) => {
          this.loader = false;
          console.log(error);
          this._toast.warning('Unable to get the internal member list!', 'Warning',
            {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            });
        }
      )
    );
  }

  getTripIdBasedOnSearchText() {
    const searchedTripId = document.getElementById('tripId');
    if (searchedTripId) {
      fromEvent(searchedTripId, 'input').pipe(
        debounceTime(1000)
      ).subscribe(
        (response) => {
          const searchText: string = (response.target as HTMLInputElement).value ? (response.target as HTMLInputElement).value.trim() : null;
          if (searchText.length > 4 && !this.getTripIdDataModel.tripIdList.some(tripId => tripId.includes(searchText.toUpperCase()))) {
            let memberID: string = (this.user.role === RoleName.CustomerAdmin || this.user.role === RoleName.CustomerCoordinator) ? this.user.businessUnitId : DefaultGUID;
            this.getTripIdIfNotFound(searchText, memberID);
          }
        }
      )
    }
  }
  getTripIdIfNotFound(searchText, memberID) {
    this._serviceRequestService.getFilterDataBasedOnSearchKeyWord(searchText, memberID).subscribe(
      (response: IFilterViewModel[]) => {
        if (response && response.length > 0) {
          const filteredTripIds = response?.filter(result => result.tripId != '').map(result => result.tripId);
          const uniqueTripIds = Array.from(new Set([...this.getTripIdDataModel.tripIdList, ...filteredTripIds]))
          this.getTripIdDataModel.tripIdList = uniqueTripIds;
        }
      },
      (error) => {
        console.log(error);
      }
    )
  }

  filterGroupChatList() {
    this.filteredSRListGroupList = this.sRListGroupList;
    if (this.getTripIdDataModel.selectedTripIdList.length > 0) {
      this.filteredSRListGroupList = this.filteredSRListGroupList?.filter((sRGroup) => {
        return this.getTripIdDataModel.selectedTripIdList.some(tripID => tripID == sRGroup.tripId);
      });
      this._internalGroupChatService.loadGroupChatSubject$.next({
        groupDetail: null,
        serviceRequestDetail: null
      })
    }
    if (this.getCustomerDataModel.selectedCustomerList.length > 0) {
      this.filteredSRListGroupList = this.filteredSRListGroupList?.filter((sRGroup) => {
        return this.getCustomerDataModel.selectedCustomerList.some(customer => customer.customerName == sRGroup.customerName);
      });
      this._internalGroupChatService.loadGroupChatSubject$.next({
        groupDetail: null,
        serviceRequestDetail: null
      })
    }
    if (this.groupNameFilterText !== '' && this.groupNameFilterText.trim().length > 0) {
      this.filteredSRListGroupList = this.filteredSRListGroupList?.filter((sRGroup) => {
        return sRGroup.groupLists.some(x => x.groupName.toLowerCase().includes(this.groupNameFilterText.toLowerCase()));
      });
      this._internalGroupChatService.loadGroupChatSubject$.next({
        groupDetail: null,
        serviceRequestDetail: null
      })
    }
  }

  getFilteredServiceRequestBasedOnSearchedText() {
    const searchInput = document.getElementById('message');
    if (searchInput) {
      fromEvent(searchInput, 'input').pipe(
        debounceTime(1000)
      ).subscribe((response) => {
        let getSRListGroupListPayload = {
          memberId: this.user.memberId,
          serviceRequestId: null,
          messageText: (response.target as HTMLInputElement).value ? (response.target as HTMLInputElement).value.trim() : null
        }
        this._internalGroupChatService.loadGroupChatSubject$.next(
          {
            groupDetail: null,
            serviceRequestDetail: null
          }
        )
        this.getGroupChatList(getSRListGroupListPayload);
      })
    }
  }

  showTotalUnreadMessageCount(totalCount: number) {
    this.totalMessageCount = totalCount
  }

}
